// ✅ Allowed Origins for CORS
export const allowedOrigins = [
  "https://butlerbrief.com",
  "https://www.butlerbrief.com",
  "https://bbf-web-gu9k.onrender.com", // Render PROD
  "https://bbf-web-dev.onrender.com",  // Render DEV
  "http://localhost:5173"
];

// ✅ CORS Options
export const corsOptions = {
  origin: (origin, callback) => {
    if (!origin || allowedOrigins.includes(origin)) {
      callback(null, true);
    } else {
      // console.warn(`❌ CORS Blocked: ${origin}`);
      callback(new Error("Not allowed by CORS"));
    }
  },
  methods: ["GET", "POST", "OPTIONS"],
  allowedHeaders: ["Content-Type", "Authorization"]
};

// ✅ Domain to Environment Mapping
const domainMap = [
  { domain: "butlerbrief.com", env: "prod" },
  { domain: "www.butlerbrief.com", env: "prod" },
  { domain: "bbf-web-gu9k.onrender.com", env: "prod" },
  { domain: "bbf-web-dev.onrender.com", env: "dev" },
  { domain: "localhost", env: "dev" },
  { domain: "127.0.0.1", env: "dev" }
];

/**
 * ✅ Get environment (dev/prod) from domain
 */
export const getEnvFromDomain = (hostname) => {
  if (!hostname) return "dev";
  const match = domainMap.find(entry => hostname.includes(entry.domain));
  return match ? match.env : "dev";
};

/**
 * ✅ Get ENV-specific key (appends _DEV or _PROD automatically)
 */
export const getKeyForEnv = (baseKey, env) => {
  const suffix = env.toLowerCase() === "prod" ? "_PROD" : "_DEV";
  const fullKey = `${baseKey}${suffix}`;
  const value = process.env[fullKey];
  if (!value) {
    // console.warn(`⚠️ Missing env var: ${fullKey}`);
  }
  return value;
};